import Emitter from "es6-event-emitter";

import template from "./../templates/fullscreenComponent.dust";

import {
  CLICKED_FULLSCREEN_READER,
  OPENED_FULLSCREEN_READER,
  EXIT_FULLSCREEN_READER,
  CLICKED_ESCAPE_FULLSCREEN_READER,
} from "./../../../common/analytics/analyticsevents";

export default class FullScreenComponent extends Emitter {
  constructor(options, appState) {
    super();
    this._options = options;
    this._appState = appState;
    this._DOMContainer = document.querySelector("#fullscreen-component");
    this._documentBody = document.getElementsByTagName("BODY")[0];
    this.render();
  }

  render() {
    Dust.render(template, {}, this._renderDone.bind(this));
  }

  destroy() {
    this._detachEventListeners();
    this._DOMContainer.innerHTML = "";
  }

  _renderDone(err, result) {
    if (err) return;
    this._DOMContainer.innerHTML = result;
    this._attachEventListeners();
  }

  _attachEventListeners() {
    this.fullscreenEnter =
      this._DOMContainer.querySelector("#fullscreen-enter");
    this.fullscreenExit = this._DOMContainer.querySelector("#fullscreen-exit");
    document.addEventListener(
      "fullscreenchange",
      this._onFullScreenChange,
      false
    );
    document.addEventListener(
      "MSFullscreenChange",
      this._onFullScreenChange,
      false
    );
    document.addEventListener(
      "webkitfullscreenchange",
      this._onFullScreenChange,
      false
    );
    document.addEventListener(
      "webkitfullscreeneventchange",
      this._onFullScreenChange,
      false
    );
    document.addEventListener(
      "mozfullscreenchange",
      this._onFullScreenChange,
      false
    );
    this.fullscreenEnter.addEventListener(
      "click",
      this._onFullScreenEnterClick
    );
    this.fullscreenExit.addEventListener("click", this._onFullScreenExitClick);
  }

  _detachEventListeners() {
    document.removeEventListener("fullscreenchange", this._onFullScreenChange);
    document.removeEventListener(
      "MSFullscreenChange",
      this._onFullScreenChange
    );
    document.removeEventListener(
      "webkitfullscreenchange",
      this._onFullScreenChange
    );
    document.removeEventListener(
      "webkitfullscreeneventchange",
      this._onFullScreenChange
    );
    document.removeEventListener(
      "mozfullscreenchange",
      this._onFullScreenChange
    );
    document.removeEventListener("keyup", this._onEscapeButtonKeyUp);
    this.fullscreenEnter.removeEventListener(
      "click",
      this._onFullScreenEnterClick
    );
    this.fullscreenExit.removeEventListener(
      "click",
      this._onFullScreenExitClick
    );
  }

  _requestFullScreen = (element) => {
    const requestMethod =
      element.requestFullscreen ||
      element.webkitRequestFullScreen ||
      element.mozRequestFullScreen ||
      element.msRequestFullscreen;

    if (requestMethod) {
      this._documentBody.classList.add("full-screen-mode");
      requestMethod.call(element);
    }
  };

  _onFullScreenEnterClick = () => {
    this._appState.triggerEvent(CLICKED_FULLSCREEN_READER);
    this._appState.inFullScreenMode = true;
    if (parent) {
      parent.postMessage({ event: "OnFullScreenClicked" }, "*");
    }
    this._requestFullScreen(document.body);
  };

  _onFullScreenExitClick = () => {
    this._appState.triggerEvent(CLICKED_FULLSCREEN_READER);
    this._appState.inFullScreenMode = false;
    if (parent) {
      parent.postMessage({ event: "onFullScreenExitClicked" }, "*");
    }
    this._exitFullScreen(document);
  };

  _exitFullScreen = (element) => {
    const requestMethod =
      element.exitFullscreen ||
      element.webkitExitFullscreen ||
      element.mozCancelFullScreen ||
      element.msExitFullscreen;

    if (requestMethod) {
      this._documentBody.classList.remove("full-screen-mode");
      requestMethod.call(element);
    }
  };

  _onFullScreenChange = () => {
    const fullscreenElement =
      document.fullscreenElement ||
      document.msFullscreenElement ||
      document.mozFullScreenElement ||
      document.webkitFullscreenElement;

    // if in fullscreen mode fullscreenElement won't be null
    if (!fullscreenElement) {
      /*When pressing exit the exitFullscreen is not called
        but the fullscreen is fired that is why we remove the
        full-screen-mode here*/
      this._documentBody.classList.remove("full-screen-mode");
      /*When out of fullscreen mode do not listen to the escape keyup event*/
      document.removeEventListener("keyup", this._onEscapeButtonKeyUp);
      this.trigger("fullScreenComponent:stopFullScreen");
      this._appState.triggerEvent(EXIT_FULLSCREEN_READER);
    } else {
      /*When in fullscreen mode  listen to the escape keyup event*/
      document.addEventListener("keyup", this._onEscapeButtonKeyUp);
      this.trigger("fullScreenComponent:startFullScreen");
      this._appState.triggerEvent(OPENED_FULLSCREEN_READER);
    }
  };

  _onEscapeButtonKeyUp = (e) => {
    if (e.keyCode === 27) {
      this._appState.triggerEvent(CLICKED_ESCAPE_FULLSCREEN_READER);
      this._exitFullScreen(document);
    }
  };
}



// WEBPACK FOOTER //
// ./src/web/reader/components/fullscreenComponent.js